// extracted by mini-css-extract-plugin
export default {"container":"style_container__bRIuo","divider":"style_divider__lL4cq","formFooter":"style_formFooter__zEHkG","button":"style_button__XXePD"};